import { AuthContext } from '@/contexts/auth-context'
import { useContext } from 'react'
import MostUsedUserLoyaltyCards from './most-used-cards'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/api/axiosInstance'

function UserProfile() {
  const { auth } = useContext(AuthContext)
  const { data, isLoading, error } = useQuery({
    queryKey: ['mostUsedLoyaltyCards', auth.user._id],
    queryFn: async () => {
      const response = await axiosInstance.get('web_api/customer/topCardsList', {
        params: { userId: auth.user._id },
      })
      return response.data
    },
  })

 

  return (
    <div className="container flex flex-col gap-2 md:gap-4 p-2 md:p-4">
      <h3 className="text-lg font-semibold text-gray-900">Profile Information</h3>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-[#FFDECF] shadow-sm rounded-[10px] p-6 border border-[#F1E7F5] flex flex-col items-center justify-center">
          <span className="text-sm text-gray-600 font-medium">Total spending</span>
          <p className="text-3xl text-gray-800 font-light mt-2">
            {data?.data?.businessStats?.totalPointsDebited || 0}
          </p>
        </div>

        <div className="bg-[#FFC9CA] shadow-sm rounded-[10px] p-6 border border-[#F1E7F5] flex flex-col items-center justify-center">
          <span className="text-sm text-gray-600 font-medium">Total loyalty points</span>
          <p className="text-3xl text-gray-800 font-light mt-2">
            {data?.data?.businessStats?.pointsBalance || 0}
          </p>
        </div>
      </div>

      {/* Profile Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        {/* Name Field */}
        <div className="flex flex-col gap-2">
          <label className="text-sm  text-gray-700">Name</label>
          <input
            type="text"
            value={auth?.user?.name || 'N/A'}
            readOnly
            className="px-4 py-3 rounded-lg  bg-white text-gray-800  focus:outline-none"
            style={{
              border: '1px solid #E5D2EC',
            }}
          />
        </div>

        {/* Email Field */}
        <div className="flex flex-col gap-2">
          <label className="text-sm  text-gray-700">Email Address</label>
          <input
            style={{
              border: '1px solid #E5D2EC',
            }}
            type="email"
            value={auth?.user?.email || 'N/A'}
            readOnly
            className="px-4 py-3 rounded-lg  bg-white text-gray-800  focus:outline-none"
          />
        </div>

        {/* Mobile Number Field - Full Width */}
        <div className="flex flex-col gap-2 md:col-span-2">
          <label className="text-sm  text-gray-700">Mobile Number</label>
          <input
            style={{
              border: '1px solid #E5D2EC',
            }}
            type="tel"
            value={auth?.user?.country_code?.split(' ')?.[1] + ' ' + auth?.user?.mobile || 'N/A'}
            readOnly
            className="px-4 py-3 rounded-lg  bg-white text-gray-800  focus:outline-none"
          />
        </div>
      </div>

      <MostUsedUserLoyaltyCards data={data} isLoading={isLoading} error={error} />

      {/* <h3 className="text-md font-semibold text-gray-900">Most Used Loyalty Card</h3> */}
    </div>
  )
}

export default UserProfile
